var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"wrapper__inner--narrow"},[_c('section',{class:_vm.pageCss},[(_vm.content.image)?_c('span',{staticClass:"image__wrapper"},[_c('img',{attrs:{"src":_vm.content.image}})]):_vm._e()])])])}
var staticRenderFns = []

export { render, staticRenderFns }